<div>

  <form #recurringRevForm="ngForm" novalidate="novalidate" autocomplete="off">

    <div class="row mt-5 mb-4" *ngIf="currentReport?.LATEST?.RISK && currentReport.LATEST.COMPANY.NAICS.R_RR === false && !currentReport.LATEST.RISK.OPT_RR">
      <div class="col-md-12 text-center">
        Recurring Revenue was deemed a non-factor for the company based on Industry Type.
        <p>Should you wish to determine Recurring Revenue Risk, please click <a role="button" class="color--blue"
            (click)="currentReport.isLocked ? '' : showHideRecurringRev()">here</a>.</p>
      </div>
    </div>

    <div class="row mt-5 mb-4" *ngIf="currentReport?.LATEST?.RISK && (currentReport.LATEST.COMPANY.NAICS.R_RR || currentReport.LATEST.RISK.OPT_RR)">
      <div class="col-md-12">
        <div class="label">Does the Company have a recurring revenue model?</div>
        <div class="color-secondary-gray font-size-12 font-weight-normal mb-2">(i.e. recurring membership subscriptions,
          service/maintenance contracts, monitoring
          fees, software as a service,
          annual commission income, etc.)</div>

        <div class="row" *ngIf="currentReport?.LATEST?.RISK">
          <div class="col-md-12">
            <radio-group-button radioGroupButtonId="risk-rr-is-recurring-type-radio-group"
              [selectedOption]="currentReport.LATEST.RISK.RR_IS_RECURRING" [btnList]="recurringList" [isButton]="true"
              [disabled]="currentReport?.isLocked"
              (optionChange)="currentReport.LATEST.RISK.RR_IS_RECURRING = $event; callUpdateAPI('RR_IS_RECURRING')"
              [(ngModel)]="currentReport.LATEST.RISK.RR_IS_RECURRING" #RR_IS_RECURRING="ngModel" name="RR_IS_RECURRING"
              required>
            </radio-group-button>

            <ng-container *ngIf="currentReport.LATEST.RISK.RR_IS_RECURRING == 'YES'">
              <div class="label mb-2 mt-4">What percentage of the Company’s revenues are recurring?</div>
              <radio-group-button radioGroupButtonId="risk-rr-recurring-amount-type-radio-group"
                [selectedOption]="currentReport.LATEST.RISK.RR_RECURRING_AMOUNT" [btnList]="percentageList"
                [isButton]="true" [disabled]="currentReport?.isLocked"
                (optionChange)="currentReport.LATEST.RISK.RR_RECURRING_AMOUNT = $event; callUpdateAPI('RR_RECURRING_AMOUNT')"
                [(ngModel)]="currentReport.LATEST.RISK.RR_RECURRING_AMOUNT" #RR_RECURRING_AMOUNT="ngModel"
                name="RR_RECURRING_AMOUNT" required>
              </radio-group-button>
            </ng-container>

          </div>
        </div>

      </div>
    </div>

  </form>

</div>
<report-footer
  [nextBtnEnable]="(currentReport?.LATEST?.RISK && recurringRevForm.valid) || currentReport?.isLocked"
  (buttonClicked)="footerButtonClick($event)" [extraBtnText]="'Back to Optional'"
  [extraAvailable]="!currentReport?.isLocked && !currentReport?.LATEST?.COMPANY.NAICS.R_RR && currentReport?.LATEST?.RISK.OPT_RR"
  [skipAvailable]="!currentReport?.isLocked" [skipArrow]="false" [skipBtnText]="'Reset'"
  [pageId]="reportPageConst.RECURRING_REVENUE" [mobileIcon]="'reset-icon'"></report-footer>
